import { render, staticRenderFns } from "./addReturnDiglog.vue?vue&type=template&id=19bb99f4&scoped=true"
import script from "./addReturnDiglog.vue?vue&type=script&lang=js"
export * from "./addReturnDiglog.vue?vue&type=script&lang=js"
import style0 from "./addReturnDiglog.vue?vue&type=style&index=0&id=19bb99f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb99f4",
  null
  
)

export default component.exports